import PaperContainer from 'components/PaperContainer';
import { useEffect } from 'react';
import { useCommonStore } from 'store/index';
import { tabTitle } from 'utils/index';
import PoHistory from './PoHistory';

export default function PoHistoryPage() {
  tabTitle('PO History');
  const setComponentHeading = useCommonStore((state) => state.setComponentHeading);

  useEffect(() => {
    setComponentHeading('PO History');
  }, []);

  return (
    <PaperContainer>
      <PoHistory />
    </PaperContainer>
  );
}
